export default "__VITE_ASSET__BXTLccfA__";